import React from 'react';

const Error = () => {
	return (
		<div
			className=" d-flex flex-column align-items-center justify-content-center text-center w-100 text-white"
			style={{ height: '75vh' }}>
			<h2>Error 404</h2>
			<h2>Path Not Found</h2>
		</div>
	);
};

export default Error;
